<template>
    <v-container fluid class="pa-9">
        <v-row >
            <header class="v-sheet theme--light v-toolbar v-toolbar--dense v-toolbar--flat v-app-bar" id="3" data-booted="true" style="height: 48px; margin-top: 0px; transform: translateY(0px); left: 0px; right: 0px; background-color: rgb(239, 239, 239); border-color: rgb(239, 239, 239);">
                <div class="v-toolbar__content" style="height: 48px;">
                    <v-app-bar-nav-icon>
                        <v-icon :color="siteInfo.colorInfo.iconColor">fa-list-alt</v-icon>
                    </v-app-bar-nav-icon>
                    <div class="v-toolbar__title" style="color: rgb(0, 0, 0);"> Afspraakbevestiging </div>
                </div>
            </header>
        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                De volgende afspraak is voor u gemaakt. Een afspraakbevestiging wordt naar u verstuurd.
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4" md="4">
                Datum afspraak
            </v-col>

            <v-col cols="8" md="4">
                : {{confirmationModel.appointmentMoment}}
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4" md="4">
                Type afspraak
            </v-col>

            <v-col cols="8" md="4">
                : {{confirmationModel.appointmentName}}
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4" md="4">
                Locatie
            </v-col>

            <v-col cols="8" md="4">
                : {{confirmationModel.locatieName}}
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4" md="4">
                Therapeut
            </v-col>

            <v-col cols="8" md="4">
                : {{confirmationModel.therapeutName}}
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                Heeft u vragen over de afspraak of wilt u de afspraak wijzigen, neemt u dan contact op met de praktijk.
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    /* eslint-disable */
    import { mapState } from "vuex";

    export default {
        created() {
            this.fetchData();
        },
        data: () => ({
            confirmationModel: {},
        }),
        computed: {
            ...mapState("app", ["status", "siteInfo"]),
        },
        methods: {
            fetchData() {
                this.confirmationModel = this.$route.params.confirmationModel;
            },
            close() {
                let vm = this;
                vm.$router.push('/');
                location.reload();
            }
        },
    };
</script>